// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CharacteristicsDisplay_wrapper__kSwqu"};